// Human-readable labels for approval_gate_reason values (Phase 9-UI).
//
// The backend emits snake_case reason codes on SignalModel /
// SignalHistoryRowModel (produced by _approval_gate_reason in
// app/_routers.py). Before this map, the one place that rendered
// them (SignalHistoryScreen) printed the raw code verbatim —
// tolerable for "ai_confidence_missing", operator-hostile for
// "forex_short_watch_only". Unknown codes fall back to a
// prettified form of the raw code so new backend reasons degrade
// readably instead of invisibly.

const GATE_REASON_LABELS: Record<string, string> = {
  // Phase 9a: forex shorts are watch-only until the Phase 9b
  // margin/leverage model exists — a TEMPORARY gate, unlike crypto's.
  forex_short_watch_only: "Short — watch-only (margin model pending, Phase 9b)",
  // Crypto shorts are permanently watch-only (spot venue, long-only).
  crypto_short_watch_only: "Short — watch-only (spot crypto)",
  hedge_watch_advisory_only: "Advisory only (hedge watch)",
  not_actionable_for_approval: "Not actionable",
  below_deterministic_confidence_threshold: "Below confidence floor",
  below_ai_confidence_threshold: "Below AI confidence floor",
  ai_confidence_missing: "AI unscored",
};

/** Label for a gate-reason code; null/undefined → "passed" (the
 * row reached the approval queue ungated). */
export function gateReasonLabel(reason: string | null | undefined): string {
  if (reason === null || reason === undefined || reason === "") {
    return "passed";
  }
  const known = GATE_REASON_LABELS[reason];
  if (known !== undefined) return known;
  return reason.replace(/_/g, " ");
}

/** True when the reason means "signal is visible but can never be
 * confirmed in its current state" — screens render these with the
 * idle/watch treatment rather than as an error. */
export function isWatchOnlyReason(
  reason: string | null | undefined,
): boolean {
  return (
    reason === "forex_short_watch_only" ||
    reason === "crypto_short_watch_only" ||
    reason === "hedge_watch_advisory_only"
  );
}
